import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const MedalIcon: FC<Props> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="medal icon">
      {/* <title>medal icon</title> */}
      <g id="R Icon">
        <path
          id="Vector"
          d="M6.85457 9.43883C6.07577 9.43894 5.31445 9.1981 4.66686 8.74665C4.01926 8.29527 3.5145 7.65363 3.2164 6.9029C2.91829 6.15211 2.84023 5.32598 2.99209 4.52893C3.14396 3.73188 3.51893 2.99973 4.06957 2.42505C4.62022 1.85038 5.32181 1.45901 6.08561 1.30043C6.84943 1.14184 7.64116 1.22317 8.36068 1.53414C9.08019 1.8451 9.6952 2.37172 10.1279 3.0474C10.5606 3.72309 10.7915 4.51749 10.7915 5.33014C10.7903 6.41932 10.3751 7.46356 9.6371 8.23382C8.89911 9.00407 7.89843 9.43741 6.85457 9.43883ZM6.85457 2.10604C6.24346 2.10593 5.64602 2.29492 5.13785 2.64911C4.62967 3.00331 4.23354 3.5068 3.99961 4.09592C3.76566 4.68504 3.7044 5.33331 3.82356 5.95873C3.94271 6.58421 4.23694 7.15873 4.66903 7.6097C5.10112 8.06067 5.65167 8.36781 6.25103 8.49224C6.85039 8.61668 7.47167 8.55287 8.03627 8.30883C8.60087 8.06486 9.08346 7.65163 9.42301 7.1214C9.76257 6.59117 9.94376 5.96781 9.94376 5.33014C9.94274 4.47549 9.61692 3.65615 9.03786 3.05177C8.45873 2.44739 7.6736 2.10729 6.85457 2.10604Z"
          fill={props.fill || "currentColor" || "#3064C0"}
        />
        <path
          id="Vector_2"
          d="M4.84047 12.6925C4.68784 12.6921 4.53792 12.6505 4.40534 12.5718C4.2688 12.4926 4.15519 12.3766 4.07638 12.236C3.99757 12.0954 3.95647 11.9354 3.95735 11.7726L3.94727 7.90394C3.94712 7.84648 3.95783 7.78954 3.9788 7.7364C3.99977 7.68326 4.03059 7.63496 4.06949 7.59419C4.10839 7.55347 4.1546 7.52109 4.20549 7.49899C4.2564 7.47688 4.31099 7.46539 4.36614 7.46527C4.47729 7.46539 4.58388 7.51135 4.66258 7.59314C4.74128 7.67492 4.78569 7.78581 4.78614 7.9016L4.79622 11.7708L4.86287 11.8094L6.41069 10.8422C6.54795 10.756 6.70519 10.7105 6.86541 10.7105C7.02568 10.7105 7.18293 10.756 7.32013 10.8422L8.86517 11.8082L8.93181 11.7691V7.89746C8.93181 7.78144 8.97605 7.67019 9.05484 7.58812C9.13363 7.5061 9.24043 7.45996 9.35181 7.45996C9.46319 7.45996 9.57004 7.5061 9.64883 7.58812C9.72757 7.67019 9.77181 7.78144 9.77181 7.89746V11.7691C9.77187 11.9319 9.73043 12.0919 9.65175 12.2326C9.57301 12.3733 9.45989 12.4898 9.32387 12.5701C9.18784 12.6504 9.03384 12.6917 8.87749 12.6897C8.72114 12.6877 8.56809 12.6426 8.43397 12.5589L6.88781 11.5923L5.29518 12.5595C5.15803 12.6461 5.00083 12.6921 4.84047 12.6925Z"
          fill={props.fill || "currentColor" || "#3064C0"}
        />
      </g>
    </svg>
  );
};

export default MedalIcon;
